export const isAuthenticatedCookie = 'lsAuth.user.authenticated';
export const registrationPath = 'register'